import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { ConfigurationDeviceResponse } from '@/modules/configurationModule/detail/instrumentation/devices/services/configuration-device/configuration-device.dto'
import { CommonDeviceTypeEnum, CommonDeviceTypeEnumResponse } from '@/api/services/common/device-type/common-device-type.dto'
import { commonDeviceTypeService } from '@/api/services/common/device-type/common-device-type.service'

@Component
export default class ConfigurationInstrumentationDevicesModalBasicForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly device!: Partial<ConfigurationDeviceResponse>

    @Emit()
    create(): void {}

    @Emit()
    update(): void {}

    get updateMode(): boolean {
        return !!this.device?.id
    }

    get isScanner(): boolean {
        return this.device.type?.code === CommonDeviceTypeEnum.SCANNER
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.$validator.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    async getDeviceTypes(): Promise<CommonDeviceTypeEnumResponse[]> {
        const response = await this.$_toCallSecure(commonDeviceTypeService.getDeviceTypes())
        return response ?? []
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this.updateMode) {
                this.update() // emits an event
            } else {
                this.create() // emits an event
            }
        }
    }
}
